import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  CustomCheckbox,
  CustomPanel,
  InputNumeroInteiro,
  InputText,
  OutlinedBtnPrimary,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import useAreaSeparacao from './AreaSeparacaoHook'
import ModalAreaSeparacao from './ModalAreaSeparacao'
import ModalAreaSeparacaoCliente from './ModalAreaSeparacaoCliente'
import { Fieldset } from 'primereact/fieldset'

function AreaSeparacao({ selectedTp, history, dispatch }) {
  const { state, localDispatch } = useAreaSeparacao(selectedTp)

  useEffect(() => {
    localDispatch.setSelectedTp(selectedTp, areas => localDispatch.atualizarAreas(areas))
  }, [selectedTp])

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      localDispatch.resetError()
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>4.1 - Áreas de Separação</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.showDialog('Editar', null)}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-12">
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={localDispatch.onSelecionarTodosChange}
              >
                Selecionar Todos
              </CustomCheckbox>
              <div style={{ display: 'inline-block', marginLeft: 10 }}>
                <OutlinedBtnPrimary
                  label={"Gerar os TAG's Áreas"}
                  onClick={() => localDispatch.onBtnGerarTagAreaClick(state.areas)}
                />
              </div>
            </div>
            <div className="p-col-12" style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
              <Fieldset legend={'Gerar Areas de Separação'} toggleable collapsed>
                <div className="p-grid p-col-6 p-justify-between p-align-center">
                  <InputNumeroInteiro
                    label={'Quantidade'}
                    value={state.qte}
                    onChange={value => localDispatch.onInputChange('qte', value)}
                  />
                  <InputText
                    label={'Nome'}
                    value={state.name}
                    onChange={value => localDispatch.onInputChange('name', value)}
                  />
                  <InputNumeroInteiro
                    label={'Contador do Nome Inicia Em'}
                    value={state.comecaEm}
                    onChange={value => localDispatch.onInputChange('comecaEm', value)}
                  />
                  <div style={{ marginTop: 30 }}>
                    <Btn
                      onClick={() =>
                        localDispatch.onGerarAreasClick(
                          state.qte,
                          state.name,
                          state.comecaEm,
                          selectedTp,
                          state.areas,
                        )
                      }
                    >
                      Gerar Areas
                    </Btn>
                  </div>
                </div>
              </Fieldset>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.areas}
                emptyMessage="Não existe área cadastrada"
                loading={state.isLoading}
              >
                <Column
                  header="#"
                  style={tableCellCentered(80)}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected === true}
                      onChange={() => localDispatch.onItemCheckboxClick(item)}
                    />
                  )}
                />
                <Column field="name" header="Área de Separação" />
                <Column field="sequence" header="Sequência" style={tableCellCentered(150)} />
                <Column
                  field="actived"
                  header="Ativo"
                  style={{ textAlign: 'center', width: 100 }}
                  body={rowData => <CustomCheckbox disabled checked={rowData.actived} />}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(80)}
                  body={item => (
                    <ThreeDots
                      items={['Editar', 'Assoc. Cliente']}
                      onClick={menuItem => localDispatch.showDialog(menuItem, item)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalAreaSeparacao
        selectedArea={state.selectedArea}
        existingAreas={state.areas}
        onHide={localDispatch.hideDialog}
        onResponse={(type, payload) =>
          localDispatch.onEditarDialogResponse(type, payload, state.areas)
        }
        visible={state.showDialog === 'EDITAR'}
      />
      <ModalAreaSeparacaoCliente
        selectedTp={selectedTp}
        selectedArea={state.selectedArea}
        onHide={localDispatch.hideDialog}
        onResponse={localDispatch.onAssocClienteDialogResponse}
        visible={state.showDialog === 'ASSOC CLIENTE'}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(AreaSeparacao))